<template>
    <div class="c-herofilter__row">
        <div class="c-herofilter__col c-herofilter__type" v-if="objectSoorten && objectFilter">
            <b-dropdown no-flip :dropup="dropup" variant="filter" ref="dropdown" id="ddselecttype">
                <template v-slot:button-content>
                    <span class="btn__lbl">{{ $t('Frontis.Vue.Search.TypeLabel') }}</span>
                    <span class="btn__val valsm">{{ selectedType }}</span>
                </template>
                <div class="radiolist" :id="`accommodation-type-${id}`">
                    <div class="custom-control custom-radio">
                        <input type="radio" class="custom-control-input" name="accommodation-type" v-on:click="setType(0)" :id="`accommodation-all-${id}`" />
                        <label class="custom-control-label" :for="`accommodation-all-${id}`">{{ $t('Frontis.Vue.Search.AllTypes') }}</label>
                    </div>
                    <div class="custom-control custom-radio">
                        <input type="radio" class="custom-control-input" name="accommodation-type" v-on:click="setType(1003)" :id="`accommodation-accommodation-${id}`" />
                        <label class="custom-control-label" :for="`accommodation-accommodation-${id}`">{{ $t('Frontis.Vue.Search.Accomodations') }}</label>
                    </div>
                    <div class="custom-control custom-radio">
                        <input type="radio" class="custom-control-input" name="accommodation-type" v-on:click="setType(1002)" :id="`accommodation-camping-${id}`" />
                        <label class="custom-control-label" :for="`accommodation-camping-${id}`">{{ $t('Frontis.Vue.Search.Camping') }}</label>
                    </div>
                </div>
            </b-dropdown>
        </div>
        <div class="c-herofilter__col c-herofilter__date" :data-calendarpos="dropup ? 'dropup' : 'dropdown'">
            <functional-calendar v-if="calendarDataLoaded" v-model="calendarData" :configs="calendarConfigs" ref="dtbDatepicker" v-on:choseDay="checkRange" v-on:opened="configureCalendar">
                <template #dateRangeInputs="props">
                    <label for="check-in" class="inputwrapper">
                        <input
                            idtype="text"
                            :title="calendarConfigs.placeholder.split(',')[0]"
                            v-model="props.startDate"
                            :placeholder="calendarConfigs.placeholder.split(',')[0]"
                            :readonly="!calendarConfigs.isTypeable"
                        />
                        <div class="inputwrapper__lbl">{{ calendarConfigs.placeholder.split(',')[0] }}</div>
                        <div class="inputwrapper__day">{{ getDayValue(calendarData.dateRange.start) }}</div>
                        <div class="inputwrapper__mnd">{{ getMonthValue(calendarData.dateRange.start) }}</div>
                    </label>
                    <label for="check-out" class="inputwrapper">
                        <input type="text" :title="calendarConfigs.placeholder.split(',')[1]" v-model="props.endDate" :placeholder="calendarConfigs.placeholder.split(',')[1]" :readonly="!calendarConfigs.isTypeable" />
                        <div class="inputwrapper__lbl">{{ calendarConfigs.placeholder.split(',')[1] }}</div>
                        <div class="inputwrapper__day">{{ getDayValue(calendarData.dateRange.end) }}</div>
                        <div class="inputwrapper__mnd">{{ getMonthValue(calendarData.dateRange.end) }}</div>
                    </label>
                </template>
            </functional-calendar>
        </div>
        <div class="c-herofilter__col c-herofilter__people">
            <b-dropdown no-flip :dropup="dropup" :right="dropup" variant="filter">
                <template v-slot:button-content>
                    <span class="btn__lbl">Voor</span>
                    <span class="btn__val">
                        {{ totaalAantalPersonen }}
                    </span>
                    <span class="btn__unt">
                        <template v-if="totaalAantalPersonen === 1">{{ $t('Frontis.Vue.PersonAbbreviation') }}</template>
                        <template v-else>{{ $t('Frontis.Vue.PersonsAbbreviation') }}</template>
                    </span>
                </template>
                <qty-inc-dec :value="localStorageData.volwassenen" name="volwassenen" :label="`${$t('Frontis.Vue.Adults')}`" :sublabel="`${$t('Frontis.Vue.From19Year')}`" @value-changed="updateQty" />
                <qty-inc-dec :value="localStorageData.jongvolwassenen" name="jongvolwassenen" :label="`${$t('Frontis.Vue.Teenagers')}`" :sublabel="`${$t('Frontis.Vue.From13to18Year')}`" @value-changed="updateQty" />
                <qty-inc-dec :value="localStorageData.kinderen" name="kinderen" :label="`${$t('Frontis.Vue.Children')}`" :sublabel="`${$t('Frontis.Vue.From5to12Year')}`" @value-changed="updateQty" />
                <qty-inc-dec :value="localStorageData.babys" name="babys" :label="`${$t('Frontis.Vue.Babys')}`" :sublabel="`${$t('Frontis.Vue.From0to4Year')}`" @value-changed="updateQty" />
            </b-dropdown>
        </div>
        <div class="c-herofilter__col c-herofilter__btn">
            <button class="btn btn-primary" v-on:click="clickFilter()">{{ $t('Frontis.Vue.Search') }}</button>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import { FunctionalCalendar } from 'vue-functional-calendar';
import { serverBus } from '../../components.js';
import { analytics } from '../../util/helper';
import QtyIncDec from './../detweebruggen/tools/qty-inc-dec.vue';

export default {
    name: 'DateFilter',
    components: { 'qty-inc-dec': QtyIncDec, FunctionalCalendar },
    data() {
        return {
            calendarDataLoaded: false,
            calendarData: {
                dateRange: { start: '', end: '' }
            },
            calendarConfigs: {
                isSeparately: false,
                isTypeable: false,
                isDateRange: true,
                isMultiple: true,
                calendarsCount: 2,
                isModal: true,
                isAutoCloseable: true,
                sundayStart: false,
                placeholder: '',
                dateFormat: 'dd-mm-yyyy',
                limits: {
                    min: '',
                    max: ''
                },
                showWeekNumbers: true,
                dayNames: ['MO', 'TU', 'WED', 'THU', 'FRI', 'SAT', 'SUN']
            },
            dummy: '',
            localStorageData: null,
            objectSoorten: null,
            loaded: false,
            type: 0,
            locAnchor: '#results',
            locale: 'nl'
        };
    },
    props: {
        beperktBoekenTot: {
            type: Date
        },
        dropup: {
            type: Boolean,
            required: false,
            default: false
        },
        googleAnalytics: {
            type: String,
            required: false,
            default: null
        },
        id: {
            type: Number,
            default: 1
        },
        objectFilter: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        dayNames() {
            return [thisObj.dayName('Mo'), thisObj.dayName('Tu'), thisObj.dayName('We'), thisObj.dayName('Th'), thisObj.dayName('Fr'), thisObj.dayName('Sa'), thisObj.dayName('Su')];
        },
        dateStart: {
            get() {
                return this.localStorageData.ingevoerd ? this.localStorageData.dateStart : '';
            },
            set(newVal) {
                this.localStorageData.dateStart = newVal;
            }
        },
        dateEnd: {
            get() {
                return this.localStorageData.ingevoerd ? this.localStorageData.dateEnd : '';
            },
            set(newVal) {
                this.localStorageData.dateEnd = newVal;
            }
        },
        selectedType() {
            if (this.type === 0) {
                return this.$t('Frontis.Vue.Search.AllTypes');
            } else if (this.type === 1002) {
                return this.$t('Frontis.Vue.Search.Camping');
            } else if (this.type === 1003) {
                return this.$t('Frontis.Vue.Search.Accomodations');
            }
            return this.$t('Frontis.Vue.Search.AllTypes');
        },
        totaalAantalPersonen() {
            let data = this.localStorageData;
            if (this.localStorageData) {
                return data.volwassenen + data.jongvolwassenen + data.kinderen + data.babys;
            }
            return 0;
        }
    },
    mounted() {
        let thisObj = this;
        let lang = JSON.parse(localStorage.getItem('language'));
        this.$i18n.set(lang);
        this.locale = lang;
        this.type = this.localStorageData.objectSoortId;

        // bepaal de maximaal te selecteren datum, gebaseerd op setting in Umbraco.
        let maxDate = new Date(2099, 1, 1);
        if (this.beperktBoekenTot !== undefined) {
            maxDate = this.beperktBoekenTot;
            let currentSelected = moment(this.localStorageData.dateEnd, 'DD-MM-YYYY');
            if (currentSelected > maxDate) {
                // Arrangementen forceren een andere datum, dat buiten de setting kan liggen. Deze kan de max date daarom tijdelijk overrulen
                maxDate = currentSelected.toDate();
            }
        }

        this.$store.dispatch('setLanguage', lang).then(function() {
            const minDate = new Date();
            if (minDate.getHours() >= 17 || (minDate.getHours() === 16 && minDate.getMinutes() > 45)) {
                minDate.setDate(minDate.getDate() + 1);
            }
            thisObj.calendarConfigs.dayNames = [thisObj.dayName('Mo'), thisObj.dayName('Tu'), thisObj.dayName('We'), thisObj.dayName('Th'), thisObj.dayName('Fr'), thisObj.dayName('Sa'), thisObj.dayName('Su')];
            thisObj.calendarConfigs.monthNames = [
                thisObj.monthName('Jan'),
                thisObj.monthName('Feb'),
                thisObj.monthName('Mar'),
                thisObj.monthName('Apr'),
                thisObj.monthName('May'),
                thisObj.monthName('Jun'),
                thisObj.monthName('Jul'),
                thisObj.monthName('Aug'),
                thisObj.monthName('Sep'),
                thisObj.monthName('Oct'),
                thisObj.monthName('Nov'),
                thisObj.monthName('Dec')
            ];

            thisObj.calendarConfigs.placeholder = thisObj.$t('Frontis.Vue.Search.Arrival') + ',' + thisObj.$t('Frontis.Vue.Search.Departure');
            thisObj.calendarConfigs.limits.min = moment(minDate).format('D-M-YYYY');
            thisObj.calendarConfigs.limits.max = moment(maxDate).format('D-M-YYYY');

            if (thisObj.dateEnd !== '' && thisObj.dateEnd !== null && thisObj.dateStart !== '' && thisObj.dateStart !== null) {
                thisObj.calendarData.dateRange.start = moment(new Date(moment(thisObj.dateStart, 'DD-MM-YYYY'))).format('D-M-YYYY');
                thisObj.calendarData.dateRange.end = moment(new Date(moment(thisObj.dateEnd, 'DD-MM-YYYY'))).format('D-M-YYYY');
            }
            thisObj.calendarDataLoaded = true;
            thisObj.loaded = true;

            document.body.classList.add('filter-loaded');
        });
    },
    created() {
        serverBus.$on('filter-input', this.forceUpdate);
        this.localStorageData = this.$store.getters['currentSession/getLocalStorageData'];
        let currentSession = this.$store.state.currentSession;
        this.lang = JSON.parse(localStorage.getItem('language'));
        if (this.objectFilter) {
            this.objectSoorten = {
                Kamperen: '1',
                Verhuur: '2'
            };
        } else {
            this.filter(false);
        }
        if (this.beperktBoekenTot === undefined) {
            console.warn('date range incomplete (beperkt boeken tot)! ', this.beperktBoekenTot);
        }
    },
    methods: {
        constructURL() {
            // Collect filter values
            const ageGroupLines = [];
            if (this.localStorageData.volwassenen > 0) {
                ageGroupLines.push(`3429,${this.localStorageData.volwassenen}`); // Adults
            }
            if (this.localStorageData.jongvolwassenen > 0) {
                ageGroupLines.push(`3430,${this.localStorageData.jongvolwassenen}`); // Teenagers
            }
            if (this.localStorageData.kinderen > 0) {
                ageGroupLines.push(`3431,${this.localStorageData.kinderen}`); // Children
            }
            if (this.localStorageData.babys > 0) {
                ageGroupLines.push(`3432,${this.localStorageData.babys}`); // Babies
            }

            const numOfPersons = this.localStorageData.volwassenen + this.localStorageData.jongvolwassenen + this.localStorageData.kinderen + this.localStorageData.babys;

            const dateFrom = moment(this.calendarData.dateRange.start, 'DD-MM-YYYY').format('YYYY-MM-DD');
            const dateTo = moment(this.calendarData.dateRange.end, 'DD-MM-YYYY').format('YYYY-MM-DD');

            // Accommodation category (e.g., camping: 4190)
            let accommodationCategory = null;
            if (this.type !== 0) {
                accommodationCategory = this.type === 1002 ? 4190 : 4191;
            }

            // Default to Dutch URL
            let baseURL = '/online-boeken/';
            if (document.documentElement.lang === 'de') {
                baseURL = '/online-buchen/';
            } else if (document.documentElement.lang === 'en') {
                baseURL = '/book-online/';
            }

            // Construct the base URL
            let url = `${baseURL}?ageGroupLines%5B%5D=${ageGroupLines.join('&ageGroupLines%5B%5D=')}&numOfPersons=${numOfPersons}&dateFrom=${dateFrom}&dateTo=${dateTo}`;

            // Append accommodationCategory if it's set
            if (accommodationCategory !== null) {
                url += `&accommodationCategory=${accommodationCategory}`;
            }

            return url;
        },

        checkRange() {
            if (this.calendarData.dateRange !== undefined) {
                if (this.calendarData.dateRange.start !== '' && this.calendarData.dateRange.end !== '') {
                    this.dateStart = moment(this.calendarData.dateRange.start, 'D-MM-YYYY').format('DD-MM-YYYY');
                    this.dateEnd = moment(this.calendarData.dateRange.end, 'D-MM-YYYY').format('DD-MM-YYYY');
                    this.localStorageData.dateStart = moment(this.calendarData.dateRange.start, 'D-MM-YYYY').format('DD-MM-YYYY');
                    this.localStorageData.dateEnd = moment(this.calendarData.dateRange.end, 'D-MM-YYYY').format('DD-MM-YYYY');
                }
            }
        },
        clickFilter() {
            this.filter(true);
            const generatedURL = this.constructURL();
            // Redirect to the generated URL
            window.location.href = generatedURL;
        },
        configureCalendar() {
            if (localStorage.dateStart) {
                this.goToDate(localStorage.dateStart);
            }
        },
        dayName(dayname) {
            return this.$t('Frontis.Vue.Dayname.' + dayname);
        },
        filter(isButtonClicked) {
            // Send event to google analytics.
            if (this.googleAnalytics) {
                let arrival = this.localStorageData.dateStart;
                let departure = this.localStorageData.dateEnd;
                // {{arrival}}|{{departure}}|{{idobjecttype}}|{{kind}}|{{park}}|{{country}}|{{region}}
                analytics(this.googleAnalytics).track('list-search', {
                    category: 'stratech',
                    label: `${arrival}|${departure}|${this.type || ''}|||nl|`
                });
            }

            this.$store.dispatch('currentSession/setLocalStorageData', { key: 'dateStart', value: this.localStorageData.dateStart, isUmsRelated: isButtonClicked });
            this.$store.dispatch('currentSession/setLocalStorageData', { key: 'dateEnd', value: this.localStorageData.dateEnd, isUmsRelated: isButtonClicked });
            this.$store.dispatch('currentSession/setLocalStorageData', { key: 'volwassenen', value: this.localStorageData.volwassenen, isUmsRelated: isButtonClicked });
            this.$store.dispatch('currentSession/setLocalStorageData', { key: 'kinderen', value: this.localStorageData.kinderen, isUmsRelated: isButtonClicked });
            this.$store.dispatch('currentSession/setLocalStorageData', { key: 'jongvolwassenen', value: this.localStorageData.jongvolwassenen, isUmsRelated: isButtonClicked });
            this.$store.dispatch('currentSession/setLocalStorageData', { key: 'babys', value: this.localStorageData.babys, isUmsRelated: isButtonClicked });
            this.$store.dispatch('currentSession/setLocalStorageData', { key: 'accommodatietype', value: this.type, isUmsRelated: isButtonClicked });
            this.$store.dispatch('currentSession/setLocalStorageData', { key: 'ingevoerd', value: true });

            if (this.objectFilter) {
                this.$store.dispatch('currentSession/setLocalStorageData', { key: 'objectSoortId', value: this.type });
                this.$store.commit('currentSession/setObjectSoortIdZoeken', this.type);
            }

            // serverBus.$emit('search-performed', this.localStorageData);
        },
        forceUpdate(data) {
            this.localStorageData.dateStart = data.AankomstDatum;
            this.localStorageData.dateEnd = data.VertrekDatum;

            this.localStorageData.volwassenen = data.volwassenen;
            this.localStorageData.jongvolwassenen = data.jongvolwassenen;
            this.localStorageData.kinderen = data.kinderen;
            this.localStorageData.babys = data.babys;

            this.localStorageData.ingevoerd = data.ingevoerd;
            this.$forceUpdate();
        },
        getDayValue(date) {
            const curDate = date !== '' ? new Date(moment(date, 'DD-MM-YYYY')) : new Date(moment(new Date(), 'DD-MM-YYYY'));
            return curDate.toLocaleString(this.locale, { day: 'numeric' });
        },
        getMonthValue(date) {
            const curDate = date !== '' ? new Date(moment(date, 'DD-MM-YYYY')) : new Date(moment(new Date(), 'DD-MM-YYYY'));
            return curDate.toLocaleString(this.locale, { month: 'short' });
        },
        goToDate(date) {
            var formattedDate = moment(date, 'D-MM-YYYY').format('DD-MM-YYYY');
            this.$refs.dtbDatepicker.ChooseDate(formattedDate);
        },
        monthName(monthName) {
            return this.$t('Frontis.Vue.Monthname.' + monthName);
        },
        setType(type) {
            this.type = type;
            this.$refs.dropdown.hide(true);
        },
        updateQty(event) {
            // console.log(event);
            // console.log('?', event.value);
            this.localStorageData[event.name] = event.value;
            this.$store.dispatch('currentSession/setLocalStorageData', { key: event.name, value: event.value });
        }
    }
};
</script>
